module.exports = __webpack_public_path__ + "img/icon-button-find.b8088945.svg";